import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "create-trainer-modal"
}
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi-plus-lg" }, null, -1)
const _hoisted_4 = { class: "ms-2 link-navigate" }
const _hoisted_5 = { class: "d-flex flex-row-reverse mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddEntitySelect = _resolveComponent("AddEntitySelect")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitForm = _resolveComponent("MrUiKitForm")!
  const _component_MrUiKitModal = _resolveComponent("MrUiKitModal")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MrUiKitModal, { onClose: _ctx.onClose }, {
          header: _withCtx(() => [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t("common.modals.createTrainer.title")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_AddEntitySelect, {
              entity: _ctx.trainerEntity,
              onCreate: _ctx.onCreateTrainer
            }, null, 8, ["entity", "onCreate"]),
            (!_ctx.showForm)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showForm = true)),
                  class: "text-primary button-add"
                }, [
                  _hoisted_3,
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.t("common.fields.addNew")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showForm)
              ? (_openBlock(), _createBlock(_component_MrUiKitForm, {
                  key: 1,
                  modelValue: _ctx.trainer,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainer) = $event)),
                  fields: _ctx.fields,
                  onSubmit: _ctx.onSubmit,
                  "onUpdate:form": _ctx.onUpdateForm
                }, {
                  default: _withCtx(({ disabled }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_MrUiKitButton, {
                        onClick: _ctx.onSubmit,
                        classes: ['ms-2', 'btn-primary'],
                        disabled: disabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("common.operations.save")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_MrUiKitButton, {
                        type: "button",
                        classes: ['btn-white'],
                        onClick: _ctx.onClose
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("common.operations.close")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "fields", "onSubmit", "onUpdate:form"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose"])
      ]))
    : _createCommentVNode("", true)
}